export default __webpack_public_path__ + "static/media/calendar.b54e775a.svg";